<main class="shell">
  <aside class="palette">
    <div class="palette-title">
      Elements
      <span>drag to canvas</span>
    </div>

    <button
      *ngFor="let item of paletteItems"
      class="palette-item"
      type="button"
      (pointerdown)="startPaletteDrag($event, item.key, item.label)"
    >
      <span class="palette-icon">{{ item.badge }}</span>
      {{ item.label }}
    </button>
  </aside>

  <div class="toolbar">
    <strong>Flow Canvas</strong>
    <button type="button" (click)="fitView()">Fit view</button>
    <button type="button" (click)="centerViewAndDraw()">Center</button>
    <button type="button" (click)="clearConnections()">Clear connections</button>
  </div>

  <canvas
    #flowCanvas
    [class.dragging]="isDraggingCanvas"
    [class.connecting]="!!connecting"
    (pointerdown)="onCanvasPointerDown($event)"
    (pointermove)="onCanvasPointerMove($event)"
    (pointerup)="onCanvasPointerUp($event)"
    (pointercancel)="onCanvasPointerUp($event)"
    (wheel)="onWheel($event)"
    (contextmenu)="onCanvasContextMenu($event)"
  ></canvas>

  <div
    class="drag-ghost"
    *ngIf="paletteDrag"
    [style.left.px]="paletteDrag.x"
    [style.top.px]="paletteDrag.y"
  >
    {{ paletteDrag.label }}
  </div>

  <div
    class="node-menu"
    *ngIf="contextNode"
    [style.left.px]="menuPosition.x"
    [style.top.px]="menuPosition.y"
    (pointerdown)="$event.stopPropagation()"
  >
    <button type="button" (click)="deleteContextNode()">Delete</button>
  </div>

  <div class="hint">
    Drag elements from the left box to create nodes · drag nodes to move · drag port to port to connect · wheel to zoom · right-click node to delete
  </div>
</main>
